import { jsonMember, jsonObject } from 'typedjson';

@jsonObject
export class PublicBrandCategoryCollectionItemResponse {
  @jsonMember(String)
  public readonly name!: string;
}
